import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import OiButton from '../../../../../shared/components/Common/OiButton/OiButton';
import { getAccounts } from '../../../../../shared/services/bin/bankAccounts';
import Modal from '../../../../../shared/components/modal/modal';
import AddNewBank from '../../../../../shared/components/AddNewBank';
import UpdateBank from './UpdateBank/';
import { deleteBankAccountByMerchant, getBankAccountByMerchant, getBanks, setModal } from '../../../../../store/action';
import DeleteModal from '../../../../../shared/components/modal/DeleteModal';

const BankAccounts = () => {
    const { addNewBankModal, updateBankModal, deleteBankAccountModal, processLoading, allBanks } = useSelector(
        ({ Util }) => Util
    );
    const { merchantDetails, toggledAppMode } = useSelector(({ Merchants }) => Merchants);
    const { bankAccounts } = useSelector(({ Settings }) => Settings);
    const merchantId = merchantDetails[0]?.id;
    const dispatch = useDispatch();
    const [state, setState] = useState({
        data: [],
        selectedBankAccount: {}
    });
    useEffect(() => {
        if (!merchantId) return;
        dispatch(getBanks());
        dispatch(getBankAccountByMerchant({ merchantId }));
        setState({ data: getAccounts() });
        // re-fetch when the Test/Live mode changes so stale accounts from the other mode aren't shown
    }, [merchantId, toggledAppMode]);

    const handleToggleNewBank = () => {
        dispatch(setModal({ addNewBankModal: !addNewBankModal, error: '' }));
    };
    const handleToggleUpdateBank = () => {
        dispatch(setModal({ updateBankModal: !updateBankModal, error: '' }));
    };
    const handleToggleDeleteBank = () => {
        dispatch(setModal({ deleteBankAccountModal: !deleteBankAccountModal }));
    };
    const handleDeleteBank = () => {
        const bankAccountId = state.selectedBankAccount.id;
        dispatch(deleteBankAccountByMerchant({ bankAccountId }));
    };
    const { selectedBankAccount } = state;

    return (
        <div className="oi-team__background">
            <Modal
                modalVisibility={addNewBankModal}
                onModalChange={() => handleToggleNewBank()}
                styles="oi-modal__cardwd--400">
                <AddNewBank />
            </Modal>
            <Modal
                modalVisibility={updateBankModal}
                onModalChange={() => handleToggleUpdateBank()}
                styles="oi-modal__cardwd--400">
                <UpdateBank selectedBankAccount={selectedBankAccount} />
            </Modal>
            <DeleteModal
                confirmationMessage="Are You sure you want to Delete this Bank Account?"
                modalVisibility={deleteBankAccountModal}
                onModalChange={() => handleToggleDeleteBank()}
                loading={processLoading}
                handleConfirm={handleDeleteBank}
            />

            <div className="oi-team__header">
                <div className="settings__header-column">
                    <h2 className="settings__header u-half-gradient-bg">
                        {bankAccounts.length > 1 ? 'Bank Accounts' : 'Bank Account'}
                    </h2>
                    <span className="oi-team__numbers">{bankAccounts.length}</span>
                </div>

                <div
                    className="oi-btn__containers oi-team__btn-wrapper"
                    onClick={() => {
                        handleToggleNewBank();
                    }}>
                    <OiButton styles={'oi-btn__iconfy oi-btn--height3  oi-btn__style-add'}>Add New Bank</OiButton>
                </div>
            </div>

            <div className="oi-team__table-background">
                <table className="oi-table-pry">
                    <thead className="oi-table-pry__head">
                        <tr className="oi-table-pry__row">
                            <th scope="col" className="oi-table-pry__header">
                                <span className="oi-table-pry__header-mod">S/N</span>
                            </th>
                            <th scope="col" className="oi-table-pry__header">
                                Account Name
                            </th>
                            <th scope="col" className="oi-table-pry__header">
                                Account Details
                            </th>
                            <th scope="col" className="oi-table-pry__header">
                                Account Type
                            </th>
                            <th scope="col" className="oi-table-pry__header">
                                Actions
                            </th>
                        </tr>
                    </thead>

                    <tbody className="oi-table-pry__body">
                        {bankAccounts.map((item, idx) => (
                            <tr key={item.id} className="oi-table-pry__row">
                                <td
                                    data-aria-label="S/N"
                                    className="oi-table-pry__data  oi-table-pry__data-mod  u-font-semibold">
                                    <span className="mobile-s_n">{idx + 1}</span>
                                </td>
                                <td data-aria-label="Name:" className="oi-table-pry__data  u-font-semibold">
                                    {item.alias || 'No Account Name'}
                                </td>
                                <td data-aria-label="Account Details:" className="oi-table-pry__data">
                                    {`${item.accountNumber} - ${allBanks.find(bank => item.bankId === bank.id)?.name}`}
                                </td>
                                <td data-aria-label="Account Status:" className="oi-table-pry__data">
                                    {item.primaryAccount ? 'Primary' : 'Secondary'}
                                </td>

                                <td className="oi-table-pry__data">
                                    <div className="oi-button-flex">
                                        <OiButton
                                            styles="oi-btn oi-btn--purple oi-btn__icon-edit oi-btn--bordcol-purp oi-btn--width45 oi-btn--height28  oi-btn--radius5"
                                            onClick={() => {
                                                setState({ ...state, selectedBankAccount: item });
                                                handleToggleUpdateBank();
                                            }}
                                        />

                                        <div className="oi-btn__horiz-line" />

                                        <OiButton
                                            styles="oi-btn oi-btn--tertiary oi-btn__icon-delete oi-btn--bordcol-danger oi-btn--width45 oi-btn--height28 oi-btn--radius5"
                                            onClick={() => {
                                                handleToggleDeleteBank();
                                                setState({ ...state, selectedBankAccount: item });
                                            }}
                                        />
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default BankAccounts;
